export const dryingCategoryOptions = [
  { key: 1, title: "活动晾晒" },
  { key: 2, title: "“同心·公益”学堂" },
];
export const getDryingCategoryText = function (cat) {
  const res = dryingCategoryOptions.find((s) => s.key == cat);
  return res ? res.title : null;
};

export default {
  name: "新闻",
  listTitle: "新闻列表",
  url: "/activity-air", // rest接口表名
  query: "&sort=-release_time", // rest接口query参数
  // 列表渲染列
  columns: (ctx) => {
    // eslint-disable-next-line no-unused-vars
    const h = ctx.$createElement;
    return [
      { title: "新闻标题", dataIndex: "name" },
      {
        title: "新闻类别",
        dataIndex: "cat",
        customRender: (text) => <span>{getDryingCategoryText(text)}</span>,
      },
      {
        title: "新闻封面",
        dataIndex: "img",
        customRender: (text) => {
          const imgList = text?.split(",");
          const cover = imgList[0];
          return cover ? <img class="avatar" src={cover} /> : "无";
        },
      },
      { title: "创建时间", dataIndex: "release_time" },
      // { title: "排序", dataIndex: "sort" },
    ];
  },
  // 列表查询表单
  queryForm: [
    {
      key: "name",
      label: "",
      component: "a-input",
      props: {
        placeholder: "请输入新闻标题查询",
        allowClear: true,
      },
    },
    {
      key: "cat",
      label: "",
      component: "a-select",
      props: {
        options: dryingCategoryOptions,
        placeholder: "请选择新闻类别查询",
        allowClear: true,
      },
      style: { width: "240px" },
    },
  ],
  // 新增/编辑查询表单
  items: [
    {
      key: "name",
      label: "新闻标题",
      component: "a-input",
      props: {
        placeholder: "请输入新闻标题",
      },
      rules: [{ required: true, message: "请输入新闻标题", trigger: "blur" }],
    },
    {
      key: "cat",
      label: "新闻类别",
      component: "a-select",
      props: {
        options: dryingCategoryOptions,
        placeholder: "请选择新闻类别",
      },
      style: {
        width: "100%",
      },
      rules: [{ required: true, message: "请选择新闻类别", trigger: "change" }],
    },
    {
      key: "img",
      label: "新闻封面",
      component: "form-upload",
      props: {
        limit: 9,
      },
      rules: [{ required: true, message: "请上传新闻封面", trigger: "change" }],
    },
    {
      key: "info",
      label: "新闻详情",
      component: "rich-editor",
      rules: [{ required: true, message: "请输入新闻详情", trigger: "blur" }],
    },
    // {
    //   key: "sort",
    //   label: "排序",
    //   component: "a-input-number",
    //   props: {
    //     placeholder: "数字越小排位越前",
    //   },
    //   style: {
    //     width: "240px",
    //   },
    // },
  ],
  // 详情接口expand字段
  expand: "",
  init: {}, // 新增实体初始化字段
  // 详情渲染字段
  renderItems: (ctx) => {
    // eslint-disable-next-line no-unused-vars
    const h = ctx.$createElement;
    return [
      { label: "新闻标题", key: "name" },
      {
        label: "新闻类别",
        key: "cat",
        slot: (entity) => <span>{getDryingCategoryText(entity.cat)}</span>,
      },
      {
        label: "新闻封面",
        key: "img",
        slot: (entity) => {
          const gutter = 10;
          let width = 100;
          let span = 24;
          const imgList = entity.img?.split(",") || [];
          const len = imgList.length;
          if (len === 2) {
            span = 12;
            width = 100 * 2 + gutter;
          } else if (len > 2) {
            span = 8;
            width = 100 * 3 + gutter * 2;
          }
          return (
            <div style={{ width: `${width}px` }}>
              <a-row gutter={gutter}>
                {len
                  ? imgList.map((img) => (
                      <a-col span={span}>
                        <img class="avatar" src={img} />
                      </a-col>
                    ))
                  : "无"}
              </a-row>
            </div>
          );
        },
      },
      { label: "新闻详情", key: "info", rich: true },
      { label: "创建时间", key: "release_time" },
      // { label: "排序", key: "sort" },
    ];
  },
};
